module.exports = function squared(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += ((a[i] - b[i]) * (a[i] - b[i])) / (a[i] + b[i]);
    }
    return d;
};



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/distances/squared.js
// module id = 139
// module chunks = 0